export default {
  partner:
    'Legen Sie Ihre Stripe-Verarbeitungsgebühr fest oder bestätigen Sie eine Marge von 0 %. Bis dahin können Ihre Restaurants auf Stripe nicht live gehen.',
  partner_live_one:
    'Legen Sie Ihre Stripe-Verarbeitungsgebühr fest oder bestätigen Sie eine Marge von 0 %. Bis dahin können Ihre Restaurants auf Stripe nicht live gehen, und Ihr live geschaltetes Restaurant nimmt keine Online-Zahlungen an.',
  partner_live_other:
    'Legen Sie Ihre Stripe-Verarbeitungsgebühr fest oder bestätigen Sie eine Marge von 0 %. Bis dahin können Ihre Restaurants auf Stripe nicht live gehen, und Ihre {{count}} live geschalteten Restaurants nehmen keine Online-Zahlungen an.',
  restaurant:
    'Online-Zahlungen sind pausiert, bis Ihr Partner seine Verarbeitungsgebühr festlegt. Barzahlungen funktionieren weiter.',
  cta: 'Verarbeitungsgebühr festlegen',
};
